/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { paymentTypeEnumSchema } from "./paymentTypeEnumSchema.ts";
import { status940EnumSchema } from "./status940EnumSchema.ts";

export const paymentResponseSchema = z.object({
	id: z.uuid(),
	user: z.uuid().nullish(),
	status: status940EnumSchema
		.optional()
		.describe(
			"* `created` - Создан\n* `paid` - Оплачен\n* `cancelled` - Отменен\n* `created_request_for_refund` - Создан запрос на возврат средств\n* `waiting_for_refund` - Ожидает возврата средств\n* `failed_refund` - Ошибка возврата средств\n* `refunded` - Средства возвращены",
		),
	payment_type: paymentTypeEnumSchema.optional().describe("* `card` - Карта\n* `bonus` - Бонусы\n* `external` - Внешний"),
	amount: z.string().regex(/^-?\d{0,8}(?:\.\d{0,2})?$/),
});
